










export default {
    props: {
      theme: String
    }
}
